<ng-container *ngIf="isOpen">
  <!-- Overlay -->
  <div (click)="close()" class="fixed inset-0 bg-black/50 z-[9998]"></div>

  <!-- Modal -->
  <div class="fixed z-[9999]" style="top:50%;left:50%;transform:translate(-50%,-50%);width:90vw;max-width:600px;max-height:80vh;background:#fff;border-radius:8px;box-shadow:0 25px 50px rgba(0,0,0,0.3);display:flex;flex-direction:column;overflow:hidden;font-family:sans-serif;">

    <!-- Close Button -->
    <button (click)="close()"
      class="absolute top-3 right-3 z-10 w-8 h-8 rounded-full bg-[#E86A10] text-white flex items-center justify-center hover:bg-[#d45e0e] shadow-lg">
      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
    </button>

    <!-- Content -->
    <div class="overflow-y-auto flex-1 p-6 sm:p-8">

      <h2 class="text-lg sm:text-xl font-bold text-gray-900 text-center mb-6 underline underline-offset-4" style="font-family: 'Roboto Slab', serif;">AVAILABLE COUPONS</h2>

      <!-- Manual Code Entry -->
      <div class="flex gap-2 mb-6">
        <input [(ngModel)]="manualCode" type="text" placeholder="Enter Promo *"
          class="flex-1 border border-gray-300 rounded px-4 py-3 text-sm outline-none focus:border-[#600b0b] uppercase font-mono tracking-wider" />
        <button (click)="applyManualCode()" [disabled]="loading"
          class="bg-[#E86A10] text-white px-6 py-3 rounded text-xs font-bold uppercase tracking-[0.2em] hover:bg-[#d45e0e] transition-colors disabled:opacity-50 shrink-0">
          Apply
        </button>
      </div>

      <!-- Error -->
      <p *ngIf="error" class="text-sm text-red-500 mb-4 text-center">{{ error }}</p>

      <!-- Loading -->
      <div *ngIf="loading" class="flex items-center justify-center py-8">
        <span class="w-5 h-5 border-2 border-[#600b0b] border-t-transparent rounded-full animate-spin"></span>
        <span class="ml-2 text-sm text-gray-400">Loading coupons...</span>
      </div>

      <!-- Coupon List -->
      <div *ngIf="!loading" class="space-y-4">
        <div *ngFor="let promo of promos" class="border border-gray-200 rounded-lg overflow-hidden">
          <div class="flex items-stretch">
            <!-- Code -->
            <div class="bg-[#FFF8E1] px-4 py-3 flex items-center shrink-0 border-r border-gray-200">
              <span class="text-sm font-bold text-gray-800 font-mono tracking-wider">{{ promo.code }}</span>
            </div>
            <!-- Apply Button -->
            <button (click)="applyPromo(promo)" [disabled]="isPromoDisabled(promo)"
              class="flex-1 bg-[#600b0b] text-white text-xs font-bold uppercase tracking-[0.2em] hover:bg-[#8c1c1c] transition-colors disabled:opacity-40 disabled:cursor-not-allowed">
              Apply
            </button>
          </div>
          <!-- Description -->
          <div class="px-4 py-2.5 bg-white">
            <p class="text-sm text-gray-600">{{ promo.description || promo.name }}</p>
            <p *ngIf="promo.discount_type_id === 1" class="text-xs text-green-600 font-semibold mt-1">
              Flat ₹{{ promo.discount_amount }} off
            </p>
            <p *ngIf="promo.discount_type_id === 2" class="text-xs text-green-600 font-semibold mt-1">
              {{ promo.discount_amount }}% off
            </p>
            <p *ngIf="getMinCartMessage(promo)" class="text-xs text-red-400 mt-0.5">{{ getMinCartMessage(promo) }}</p>
          </div>
        </div>

        <!-- Empty State -->
        <div *ngIf="promos.length === 0" class="text-center py-8">
          <p class="text-sm text-gray-400">No coupons available at the moment.</p>
        </div>
      </div>
    </div>
  </div>
</ng-container>
